import axios from 'axios';

// api.dhan.5cnetwork.com ONLY (excludes sendinvoiceapi/clientapi/radapi/downloadinv.dhan.*)
const DHAN_HOST = /^https?:\/\/api\.dhan\.5cnetwork\.com/;
// api.5cnetwork.com only (NOT api.dhan.5cnetwork.com)
const ADMIN_HOST = /^https?:\/\/api\.5cnetwork\.com/;

// The DHAN token is NO LONGER a build-time env var (that put it into
// bundle.js in plaintext — flagged as a vulnerability).  Instead it's
// fetched at runtime from /api/get-frontend-token AFTER OAuth login
// (see App.js) and cached in localStorage under 'dhan_api_token'.
// Read fresh on every request so a login/logout cycle picks up the
// new value without a page reload.
const getDhanToken = () => {
  try {
    return localStorage.getItem('dhan_api_token') || '';
  } catch (e) {
    return '';
  }
};

const ADMIN_TOKEN = process.env.REACT_APP_ADMIN_API_AUTH;

axios.interceptors.request.use((config) => {
  const url = config.url || '';
  const baseURL = config.baseURL || '';
  const target = url.startsWith('http') ? url : baseURL + url;

  // Don't override a header the caller already set.
  if (config.headers && config.headers.Authorization) return config;

  if (DHAN_HOST.test(target)) {
    const dhanToken = getDhanToken();
    if (dhanToken) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${dhanToken}`;
    }
  } else if (ADMIN_HOST.test(target) && ADMIN_TOKEN) {
    config.headers = config.headers || {};
    // REACT_APP_ADMIN_API_AUTH is passed raw (existing components set it
    // straight into Authorization, so the env value already carries any
    // required "Bearer " prefix).
    config.headers.Authorization = ADMIN_TOKEN;
  }
  return config;
});
